module.exports = __webpack_public_path__ + "img/ep3-2-2.5e82571e.png";